import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg' | 'xl';
  fullWidth?: boolean;
  withArrow?: boolean;
  children: React.ReactNode;
}
export function Button({
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  withArrow = false,
  className = '',
  children,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-bold rounded-xl transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2';
  const variants = {
    primary: 'bg-amber-400 hover:bg-amber-500 text-slate-900 focus:ring-amber-400 shadow-[0_4px_14px_0_rgba(251,191,36,0.39)] hover:shadow-[0_6px_20px_rgba(251,191,36,0.23)] hover:-translate-y-0.5',
    secondary: 'bg-blue-600 hover:bg-blue-700 text-white focus:ring-blue-600 shadow-lg hover:shadow-xl hover:-translate-y-0.5',
    outline: 'border-2 border-slate-200 hover:border-slate-300 text-slate-700 hover:bg-slate-50 focus:ring-slate-200'
  };
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg',
    xl: 'px-10 py-5 text-xl'
  };
  const classes = `${baseStyles} ${variants[variant]} ${sizes[size]} ${fullWidth ? 'w-full' : ''} ${className}`;
  return <motion.button whileTap={{
    scale: 0.98
  }} className={classes} {...props} data-id="element-342">
      {children}
      {withArrow && <ArrowRight className="ml-2 w-5 h-5" data-id="element-343" />}
    </motion.button>;
}